import React, {ReactNode, ReactNodeArray, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import debtPaymentBlockData from '../../../Models/Content/debtPaymentBlockData';
import DebtPayment from './debtPayment';

export default class debtPayemnt extends EpiComponent<debtPaymentBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return <DebtPayment context={this.getContext()} contentData={this.props.data} />;
  }
}
